<p>transform-steps works!</p>
<div class="card">
    <p-toast></p-toast>
    <p-steps [model]="items" [(activeIndex)]="activeIndex" [readonly]="false"></p-steps>

</div>
<router-outlet></router-outlet>

<button (click)="chan()">Next</button>
